export default __webpack_public_path__ + "static/media/nointernet.b4c26af6.svg";